// extracted by mini-css-extract-plugin
export default {"imgWrapper":"home_imgWrapper__U2Zm+"};